export interface IBreakdown {
  type: string;
  label: string;
  value: string;
}

class Breakdown {
  public readonly type: string;
  public readonly label: string;
  public readonly value: string;

  constructor({ type, label, value }: { type: string; label: string; value: string }) {
    this.type = type;
    this.label = label;
    this.value = value;
  }

  public toJSON = () => ({
    type: this.type,
    label: this.label,
    value: this.value,
  });

  public static fromJSON = (json: IBreakdown): Breakdown => {
    const { type, label, value } = Object.assign({}, json);

    if (typeof type !== 'string') throw new Error('.type must be a string');
    if (typeof label !== 'string') throw new Error('.label must be a string');
    if (typeof value !== 'string') throw new Error('.value must be a string');

    return new Breakdown({
      type,
      label,
      value,
    });
  };
}

export default Breakdown;
